import React, { useEffect, useState, Fragment } from "react";
import { useTranslation } from 'react-i18next';
import { NavLink, useNavigate,useParams } from 'react-router-dom';
import { Row, Col, CardBody, Card } from "reactstrap";
import LoadingOverlay from "react-loading-overlay-ts";
import DNALoader from "../../components/Loaders/DnaLoader";
import DataTable from 'react-data-table-component';
import BusinessService from "./Businesses.service";
import DiscountCouponService from "../DiscountCoupon/Discountcoupons.service";
import AuthService from "../Authentication/auth.service";
import Alerts from "../../components/Alerts/alerts";
import { Tooltip } from "@mui/material";
import SectionFilter from "../../components/Table Filters/FamilyMembersFilter";
import PermissionAccess from '../../PermissionAccess/Access.js';
import { getFileUrl } from "../../utils/fileUtils";
import { SensitiveImage, SensitiveText } from "../../context/SensitiveInfoContext";
import PatientICReviewModal from "../DiscountCoupon/PatientICReviewModal";
import PatientICHistoryModal from "../DiscountCoupon/PatientICHistoryModal";
import ImagePreviewModal from "../../components/Modals/ImagePreviewModal";

const icStatusButtonStyle = (status) => {
  switch (status) {
    case "approved":
      return { borderColor: "#3ac47d", backgroundColor: "#1BD35A" };
    case "rejected":
      return { borderColor: "#FF0000", backgroundColor: "red" };
    case "re-submission":
      return { borderColor: "#f7b924", backgroundColor: "#f7b924", color: "#222" };
    default:
      return { borderColor: "#30b1ff", backgroundColor: "#30b1ff" };
  }
};

const TabSection = ({patient_id}) => {
  const { t, i18n } = useTranslation();
  const { id } = useParams();
  const navigate = useNavigate();
  const [sections, setSections] = useState([]);
  const [loading, setLoading] = useState(false);
  const [filterDocument1, setFilterDocument1] = useState('');
  const [selectedRows, setSelectedRows] = useState([]);
  const [pageLimit, setPageLimit] = useState(10);
  const [totalRows, setTotalRows] = useState(0);
  const [currentPage, setCurrentPage] = useState("");
  const [resetPaginationToggle, setResetPaginationToggle] = useState(false);
  const { authData, accessPages, super_admin, current_module } = PermissionAccess();
  const [hoveredImage, setHoveredImage] = useState(null);
  const [previewTitle, setPreviewTitle] = useState("");
  const [selectedId, setSelectedId] = useState('');
  const [selectedName, setSelectedName] = useState('');
  const [showICReviewModal, setShowICReviewModal] = useState(false);
  const [showICHistoryModal, setShowICHistoryModal] = useState(false);

  useEffect(() => {
    i18n.changeLanguage(localStorage.getItem('language'));
    fetchSections(0, pageLimit);
  }, [pageLimit]);

  function fetchSections(page_index, page_limit,document1) {
    setLoading(true);
    var offset = (page_index - 1) * page_limit;
    if (offset < 1) {
      offset = 0;
    }
    DiscountCouponService.getAllPatients(authData.sessionID,offset, page_limit,patient_id,document1,'').then(
      (response) => {
        setLoading(false);
        console.log("Get sections response:-", response);
        if (response.data.message === "Unauthorized") {
          AuthService.logout();
          navigate("/login");
          window.location.reload();
        } else {
          console.log(response.data);
          setSections(response.data.data);
          setTotalRows(response.data.count.count);
        }
      },
      (error) => {
        setLoading(false);
        const errContent =
          (error.response && error.response.data) ||
          error.message ||
          error.toString();
        if (errContent) {
          Alerts.swalErrorAlert(errContent);
        } else {
          Alerts.swalErrorAlert(t("Server Error, Please try again later."));
        }
      }
    );
  }

  const openICReview = (row) => {
    setSelectedId(row._id);
    setSelectedName(row.full_name || "");
    setShowICReviewModal(true);
  };

  const openICHistory = (row) => {
    setSelectedId(row._id);
    setSelectedName(row.full_name || "");
    setShowICHistoryModal(true);
  };

  const mycolumns = [

    {
      name: t('Full Name'),
      selector: "full_name",
      width: "12%",
      sortable: true,
  },
  
    {
      name: t('Profile Image'),
      width: "12%",
      selector: (row) => {
        if (row.image) {
          const imageUrl = getFileUrl(row.image);
          return (
            <SensitiveImage
              src={imageUrl}
              alt={row.full_name}
              style={{ width: "50px", height: "50px", borderRadius: "100%", cursor: "pointer" }}
              onClick={() => {
                setHoveredImage(imageUrl);
                setPreviewTitle(t("Profile Image"));
              }}
            />
          );
        } else {
          return <span>{t('No Image')}</span>;
        }
      },
      sortable: false,
    },

    {
      name: t('IC Image'),
      width: "10%",
      center: true,
      selector: (row) => {
        if (row.ic_image) {
          const imageUrl = getFileUrl(row.ic_image);
          return (
            <SensitiveImage
              src={imageUrl}
              alt="IC"
              style={{ width: "60px", height: "40px", objectFit: "cover", borderRadius: 6, cursor: "pointer" }}
              placeholderStyle={{ width: 60, height: 40, borderRadius: 6 }}
              onClick={() => {
                setHoveredImage(imageUrl);
                setPreviewTitle(t("IC Image"));
              }}
            />
          );
        }
        return <span>{t('No Image')}</span>;
      },
      sortable: false,
    },

    
    {
        name: t('Gender'),
        selector: "gender",
        width: "8%",
        sortable: true,
    },

    {
      name: t('Date of Birth'),
      selector: "dob",
      width: "10%",
      sortable: true,
  },

    {
    name: t('Phone'),
    selector: "phone",
    width: "10%",
    sortable: true,
    },

    {
    name: t('Email'),
    selector: "email",
    width: "10%",
    sortable: true,
    },

    {
      name: t('CNIC'),
      selector: (row) => <SensitiveText value={row.medical_assistant_id} />,
      width: "10%",
      sortable: true,
      },

    {
      name: t('IC Verification'),
      width: "12%",
      selector: (row) => {
        if (row.requires_ic_verification === false && !row.medical_assistant_id && !row.ic_image) {
          return <span className="text-muted">{t("N/A")}</span>;
        }
        const status = row.IC_Verification || "pending";
        return (
          <button
            type="button"
            style={icStatusButtonStyle(status)}
            className="btn btn-sm btn-hover-shine text-white"
            onClick={() => openICReview(row)}
          >
            {status}
          </button>
        );
      },
      sortable: false,
    },

      {
        name: t('Status'),
        width: '10%',
        selector: (row) => {
          return (
            <div>
              {row.status === "Active" ? (
                <button
                  type="button"
                  style={{ borderColor: '#3ac47d', backgroundColor: '#1BD35A' }}
                  className="btn btn-sm btn-success btn-hover-shine me-3"
                >
                  {row.status}
                </button>
              ) : (
                <button
                  type="button"
                  style={{ borderColor: '#FF0000', backgroundColor: 'red' }}
                  className="btn btn-sm btn-danger btn-hover-shine me-3"
                >
                  {row.status}
                </button>
              )}
            </div>
          );
        },
        sortable: true,
      },

      {
        name: t('Actions'),
        width: "8%",
        selector: (row) => (
          <div>
            <Tooltip placement="top" title={t("IC History")} arrow>
              <i
                className="pe-7s-note2 text-info btn-icon-wrapper fs-5"
                style={{ cursor: "pointer" }}
                onClick={() => openICHistory(row)}
              > </i>
            </Tooltip>
          </div>
        ),
        sortable: false,
      },

  ];


  const handleSearch = (document1) => {
    setFilterDocument1(document1);
    if (document1 !== '') {
      fetchSections(0, pageLimit,document1)
    }
  };

  const handleClear = () => {
    setFilterDocument1('');
    fetchSections(0, pageLimit);
  };
  const filteredItems = sections;

  const subHeaderComponentMemo = React.useMemo(() => {
    return (
      <SectionFilter
        onSearch={handleSearch}
        onClear={handleClear}
        filterDocument1={filterDocument1}
      />
    );
  }, [filterDocument1]);


  function handlePageChange(page_index) {
    console.log("Page index:-", page_index)
    setCurrentPage(page_index)
    fetchSections(page_index, pageLimit,filterDocument1);
  }

  async function handlePerRowsChange(newPageLimit, page_index) {
    setPageLimit(newPageLimit);
  }

  return (
    <Fragment>
      <Col md="12" className="mx-auto app-login-box">

        <Row>
          <LoadingOverlay
            tag="div"
            active={loading}
            styles={{ overlay: (base) => ({ ...base }) }}
            spinner={<DNALoader />}
          >
            <Col md="12">
              <Card className="main-card mb-3">
                <CardBody>
                  <Col md="6" style={{ float: "left", position: "absolute", zIndex: "1" }}>
                    {subHeaderComponentMemo}
                  </Col>
                  <DataTable
                    data={filteredItems}
                    columns={mycolumns}
                    pagination
                    fixedHeader
                    fixedHeaderScrollHeight="400px"
                    subHeader
                    subHeaderComponent={
                      <div>
                        
                       
                      </div>
                    }

                    paginationServer
                    paginationTotalRows={totalRows}
                    onChangePage={handlePageChange}
                    onChangeRowsPerPage={handlePerRowsChange}
                    paginationResetDefaultPage={resetPaginationToggle}

                  />
                </CardBody>
              </Card>
            </Col>
          </LoadingOverlay>
        </Row>
      </Col>

      <ImagePreviewModal
        show={!!hoveredImage}
        onClose={() => {
          setHoveredImage(null);
          setPreviewTitle("");
        }}
        src={hoveredImage}
        title={previewTitle}
      />

      <PatientICReviewModal
        show={showICReviewModal}
        patientId={selectedId}
        onClose={() => setShowICReviewModal(false)}
        onSuccess={() => fetchSections(currentPage || 0, pageLimit, filterDocument1)}
      />
      <PatientICHistoryModal
        show={showICHistoryModal}
        patientId={selectedId}
        patientName={selectedName}
        onClose={() => setShowICHistoryModal(false)}
      />

    </Fragment>
  );
};

export default TabSection;
